import React, { Component } from 'react';
import { Field } from 'redux-form';
import { ButtonGroup } from '../LeisureTravelForm/ReduxForm';
import { InfoButton } from '../../../../common/components/index';
import { get } from 'lodash';
import './styles.scss';

class PsychiatricQuestionBox extends Component {
  render() {
    const { definitions } = this.props;
    return (
      <div className="psychiatric-box">
        <div className="medical-question-text">
          <p>
            {' '}
            Would you like to exclude psychiatric conditions?{' '}
            <InfoButton
              content={get(definitions, 'b2b.medical-has-psychiatric-condition')}
            />
          </p>
        </div>
        <div className="psychiatric-checkbox" style={{ paddingTop: '15px' }}>
          <Field
            name={'data.attributes.metadata.has_medical_overrides'}
            component={ButtonGroup}
            inline
            options={[{ label: 'Yes', value: true }, { label: 'No', value: false }]}
          />
        </div>
      </div>
    );
  }
}

export default PsychiatricQuestionBox;
